import { BoxGeometry as y, Group as d, Box3 as f, Matrix4 as g, Vector3 as h } from "three";
import { createGeometry as x } from "../create-geometry/index2.js";
import { isRgView as i } from "../rg-render-types/index4.js";
import { SizeBasedOnChildren as u } from "@project-rouge/rg-core";
import { getRgMesh as c } from "../rg-render-types/index3.js";
function G(e) {
  const t = c(e);
  if (!e.children.filter(i).length) {
    e.userData.size = [0, 0, 0], t.geometry.dispose(), t.geometry = new y(0, 0, 0), t.geometry.computeBoundingBox(), t.geometry.computeBoundingSphere();
    return;
  }
  const m = {};
  e.traverse((o) => {
    if (!i(o))
      return;
    const s = o;
    if (!u.includes(s.userData.type))
      return;
    const a = c(s);
    m[o.uuid] = a.scale.clone(), a.scale.setScalar(0);
  });
  const r = new d();
  r.position.copy(e.position), r.rotation.copy(e.rotation);
  for (const o of e.children)
    i(o) && r.add(o.clone());
  const n = new f().setFromObject(r);
  n.applyMatrix4(new g().makeRotationFromQuaternion(r.quaternion.clone().invert()));
  const p = e.position.clone().sub(n.min), l = n.max.clone().sub(n.min);
  e.userData.anchor = p.clone().divide(l).toArray(), e.userData.size = n.getSize(new h()).toArray(), t.geometry.dispose(), t.geometry = x(e.userData), e.traverse((o) => {
    if (!i(o))
      return;
    const s = o;
    if (!u.includes(s.userData.type))
      return;
    c(s).scale.copy(m[o.uuid]);
  });
}
export {
  G as resizeBasedOnChildren
};
//# sourceMappingURL=index.js.map
